import { render, staticRenderFns } from "./SelectExhibition.vue?vue&type=template&id=217a2970&"
import script from "./SelectExhibition.vue?vue&type=script&lang=js&"
export * from "./SelectExhibition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports